import { defineStore } from 'pinia'
import { z } from 'zod'
import { useStorage } from '@library/composables'
import { LocalStorage } from '@library/enums'

/**
 * 驗證碼 Store
 */
export const useCaptchaStore = defineStore('captcha', () => {
  const { getStorageData, setStorageData } = useStorage()

  /** 是否呼叫過 「記錄驗證碼與IP錯誤多次 API」 */
  const _isCalledSaveIpErrorApi = ref(false)

  /** 取得驗證碼次數 */
  const captchaLoadedCount = ref(
    getStorageData({
      key: LocalStorage.CAPTCHA_LOADED_COUNT,
      zodSchema: z.coerce.number(),
      autoRemove: true
    }) ?? 0
  )

  /** 是否呼叫過 「記錄驗證碼與IP錯誤多次 API」 */
  const isCalledSaveIpErrorApi = computed(() => {
    return _isCalledSaveIpErrorApi.value
  })

  /** 取得驗證碼上限次數 */
  const captchaLoadedCountLimit = 30

  /** 取得驗證碼次數是否達到上限 */
  const isCaptchaLoadedCountOverLimit = computed(() => {
    return captchaLoadedCount.value >= captchaLoadedCountLimit
  })

  /** 設定是否呼叫過 「記錄驗證碼與IP錯誤多次 API」 */
  function setIsCalledSaveIpErrorApi(value: boolean) {
    _isCalledSaveIpErrorApi.value = value
  }

  /** 設定取得驗證碼次數 */
  function setCaptchaLoadedCount(value: number) {
    setStorageData(LocalStorage.CAPTCHA_LOADED_COUNT, value)
    captchaLoadedCount.value = value
  }

  /** 取得驗證碼次數加 1 */
  function addCaptchaLoadedCount() {
    if (!isCaptchaLoadedCountOverLimit.value) {
      setCaptchaLoadedCount(captchaLoadedCount.value + 1)
    }
  }

  /** 重置取得驗證碼次數 */
  function resetCaptchaLoadedCount() {
    setCaptchaLoadedCount(0)
  }

  return {
    isCaptchaLoadedCountOverLimit,
    isCalledSaveIpErrorApi,
    addCaptchaLoadedCount,
    setIsCalledSaveIpErrorApi,
    resetCaptchaLoadedCount
  }
})
